import React from "react"
import * as style from "./style.module.css"
import ArticleLink from "/src/components/ArticleLinkTop"

const Component = ({ articles }) => {
  return (
    <div className={style.container}>
      {articles.map((article, index) => {
        return <ArticleLink article={article} key={index} />
      })}
    </div>
  )
}

export default Component
